import { useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useSignIn } from '../../hooks/useSignIn';
import { LoginForm } from './components/LoginForm';
import { useLoginValidation, LoginFormData } from './hooks/useLoginValidation';
import { Card, CardContent } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';

export default function Login() {
  const [formData, setFormData] = useState<LoginFormData>({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { refetch } = useAuth();
  const { signIn, loading } = useSignIn();
  const { errors, validate, clearErrors, setError: setValidationError } = useLoginValidation();

  const handleFormChange = (field: keyof LoginFormData, value: string) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    // Clear field-specific errors when user starts typing
    if (errors[field]) {
      clearErrors();
    }
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    clearErrors();

    if (!validate(formData)) {
      return;
    }

    try {
      await signIn(formData.email, formData.password);
      await refetch();
      navigate('/dashboard');
    } catch (err: any) {
      const errorMessage = err.graphQLErrors?.[0]?.message || 'E-mail ou senha inválidos';
      setError(errorMessage);
      setValidationError('general', errorMessage);
    }
  };

  return (
    <div className="min-h-screen bg-primary-50 dark:bg-primary-950 flex items-center justify-center px-4">
      <Card className="max-w-md w-full p-12">
        <CardContent className="p-0">
          <h1 className="text-3xl font-light tracking-tight text-primary-950 dark:text-white mb-8">
            ENTRAR
          </h1>

          {error && (
            <Alert variant="destructive" className="mb-6">
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          )}

          <LoginForm
            formData={formData}
            onChange={handleFormChange}
            onSubmit={handleSubmit}
            errors={errors}
            loading={loading}
          />
        </CardContent>
      </Card>
    </div>
  );
}
